import * as React from 'react';
export const IcVaccine = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.88 12.88a3 3 0 00-.83 1.61 2.9 2.9 0 00.25 1.79l-3 3a1 1 0 00-.22 1.1.87.87 0 00.22.32 1.001 1.001 0 00.7.3.999.999 0 00.71-.3l3-3c.4.2.842.303 1.29.3a3 3 0 002.12-.88l1.79-1.79-4.24-4.24-1.79 1.79zm14-7.26a1.15 1.15 0 00-.21-.33l-2-2a1.15 1.15 0 00-.33-.21A1 1 0 0018 3a1 1 0 00-.921 1.385 1 1 0 00.22.325l.3.29L16 6.59l-2.29-2.3A1.05 1.05 0 0013 4a1 1 0 00-.92 1.385 1 1 0 00.22.325l.88.88-3.09 3.08 4.24 4.24 3.08-3.08.88.88a.87.87 0 00.32.22A1 1 0 0019 12a1 1 0 00.92-.62A.85.85 0 0020 11a.84.84 0 00-.08-.38 1.15 1.15 0 00-.21-.33L17.41 8 19 6.41l.29.3a.87.87 0 00.32.22A1 1 0 0020 7a1 1 0 00.92-.62A.85.85 0 0021 6a.84.84 0 00-.08-.38h-.04z'
      fill='currentColor'
    />
  </svg>
);
